// extracted by mini-css-extract-plugin
module.exports = {"wrap":"_3jIpU","price":"Rmvd6","totalDiscount":"_3goYI","toTheLeft":"_2TlEf","rowWrap":"_3A5YQ","editView":"_29G08"};